import { render, staticRenderFns } from "./formsuboptions.vue?vue&type=template&id=aa275878&scoped=true"
import script from "./formsuboptions.vue?vue&type=script&lang=js"
export * from "./formsuboptions.vue?vue&type=script&lang=js"
import style0 from "./formsuboptions.vue?vue&type=style&index=0&id=aa275878&prod&lang=css"
import style1 from "./formsuboptions.vue?vue&type=style&index=1&id=aa275878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa275878",
  null
  
)

export default component.exports